import React from 'react'
import SpotifyLogoSrc from '../img/Spotify_Logo_RGB_White.png';

export const SpotifyLogo = (props) => {

  return (
    <a href="https://open.spotify.com/" target="_blank" rel="noreferrer" ><img alt="Spotify" style={{width: '100px'}} src={SpotifyLogoSrc} /></a>
              )
}